import React, { useEffect } from "react";
import "./styles/font.css";
import "./styles/index.css";
import "./styles/tailwind.css";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import useScrollToTop from "./Hooks/useScrollToTop";
import axiosInstance from "./utils/api/axiosInstance";
import { USER_URL } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { loadCartFromServer } from "./redux/slices/CartSlice";
import useSyncDarkMode from "./Hooks/useSyncDarkMode";
import { loadWishListFromServer } from "./redux/slices/WishListSlice";
import { ClerkProvider } from '@clerk/clerk-react'

// Import your Publishable Key


function App({ isAdmin = false }) {
  const { user } = useSelector((state) => state.user);
  useScrollToTop();
  const dispatch = useDispatch();
  const CLERK_PUBLISHABLE_KEY = 'pk_test_Y2hvaWNlLWRvZS03My5jbGVyay5hY2NvdW50cy5kZXYk';

  useEffect(() => {
    console.log(CLERK_PUBLISHABLE_KEY);
    
    if (user.role !== "admin" && user.isAuthenticated) {
      axiosInstance.get(USER_URL + "/cart").then(({ data }) => {dispatch(loadCartFromServer(data.data));}).catch((e) => "");
      axiosInstance.get(USER_URL + "/wishlist").then(({ data }) => {dispatch(loadWishListFromServer(data.data));}).catch((e) => "");
    }
  }, [user]);
  return (
    <div>
       <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} afterSignOutUrl="/">
      <ToastContainer />
      <Outlet />
      </ClerkProvider>
    </div>
  );
}
export default App;
